// top-bar.js — Dynamic Top Bar state machine (BD §1.1 + Architect §H1)
// state: 'expanded' (Tab design/upload) | 'collapsed' (Tab info)

(function () {
  function whenReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  whenReady(function () {
    var topBar = document.getElementById('global-top-bar');
    var summaryText = document.getElementById('top-bar-summary-text');
    var paperSel = document.getElementById('paper-color');
    var ribbonSel = document.getElementById('ribbon-color');

    if (!topBar || !paperSel || !ribbonSel) {
      console.error('[top-bar] elements not found');
      return;
    }

    // ── §H1: tab change → top bar state ──
    // design/upload → expanded, info → collapsed
    function setState(state) {
      if (state === 'expanded') {
        topBar.classList.add('is-expanded');
        topBar.classList.remove('is-collapsed');
      } else {
        topBar.classList.add('is-collapsed');
        topBar.classList.remove('is-expanded');
      }
    }

    // 监听 tab 切换
    var tabBtns = document.querySelectorAll('.tab-btn');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-tab');
        if (tab === 'info') {
          setState('collapsed');
        } else {
          setState('expanded');
        }
      });
    });

    // ── §H1 manual override: click collapsed strip → temporary expand ──
    var collapsedStrip = document.getElementById('top-bar-summary');
    if (collapsedStrip) {
      collapsedStrip.addEventListener('click', function () {
        if (topBar.classList.contains('is-collapsed')) {
          setState('expanded');
          topBar.classList.add('is-temporary-expanded');
        }
      });
    }

    // ── 更新 collapsed 摘要文案 ──
    function updateSummary() {
      var paperLabel = paperSel.selectedOptions[0] ? paperSel.selectedOptions[0].text : '?';
      var ribbonLabel = ribbonSel.selectedOptions[0] ? ribbonSel.selectedOptions[0].text : '?';
      if (summaryText) {
        summaryText.textContent = 'Selected: ' + paperLabel + ' / ' + ribbonLabel;
      }
    }
    paperSel.addEventListener('change', updateSummary);
    ribbonSel.addEventListener('change', updateSummary);

    // Wait for app.js to populate color selects (defer 时序: app.js 在 top-bar.js 之后)
    function initAfterPopulate() {
      if (paperSel.options.length > 0 && ribbonSel.options.length > 0) {
        updateSummary();
      } else {
        if (!window.__topBarPopulateRetry__) window.__topBarPopulateRetry__ = 0;
        window.__topBarPopulateRetry__++;
        if (window.__topBarPopulateRetry__ < 20) {
          setTimeout(initAfterPopulate, 50);
        }
      }
    }
    initAfterPopulate();

    // 暴露给 admin debug
    window.__TOP_BAR__ = { setState: setState, updateSummary: updateSummary };
  });
})();
